<!--suppress ALL -->
<template>
	<v-select :items="options" v-model="model" :label="label"></v-select>
</template>

<script>

	import QuestionType from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";

	export default {
		name: "question-type-select",
		props: {value: {default: null}, label: {default: "בחר סוג שאלה"}},
		computed: {
			options() {
				return QuestionType.getAsOption();
			},
			model: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		}
	};
</script>
